import { ImageItemsProps } from './Types';
import { ImageList } from '@mui/material';
import { Box } from '@mui/system';
import Tag from '../Tag/Tag';
import ImageCard from './ImageCard';

const ImageCards = (props: ImageItemsProps) => {
  const {
    imageData,
    isLoading,
    onTagClick = () => undefined,
    onSubmitFavorite = () => undefined,
    onChangeRegistration = () => undefined, 
    selectedTags
  } = props;
  const handleOnChange = (selectedTagIds: string[]) => {
    onTagClick(selectedTagIds);
  };
  
  const formatTagsObject = (tagArray: string[], id: number) => {
    const formatTags = tagArray.map((tag: string) => {
      return {value: id, key: tag};
    });
    return formatTags;
  };

  return (
    <>
      <ImageList
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',

        }}
        gap={30}
        cols={4}
      >
        {imageData.map((item) => {          
          const { tags=[] } = item;
          return (
            <Box display='flex'
              flexDirection='column' 
              width={345}
              key={item.id}>
              <ImageCard onSubmitFavorite={onSubmitFavorite}
                onChangeRegistration={onChangeRegistration}
                item={item} isLoading={isLoading} />
              <Box mt={1} display='flex'
                justifyContent='flex-start'
                gap={2} 
                flexWrap='wrap'>
                <Tag tagItems={formatTagsObject(tags, item.id)} 
                  onChange={handleOnChange} 
                  selectedTags={selectedTags}/>
              </Box>
            </Box>
          );
        })}
      </ImageList>
      
    </>
  );
};

export default ImageCards;